export const authServiceMessages = {
  LOGIN: {
    SUCCESS: 'Login successful.',
    ERROR: 'Unable to login. Please check your credentials and try again.',
  },
  REQUEST_PASSWORD_RESET: {
    SUCCESS: 'If an account with that email exists, a password reset link has been sent.',
    ERROR: 'Unable to send password reset link. Please try again later.',
  },
  RESET_PASSWORD: {
    SUCCESS: 'Your password has been reset successfully.',
    ERROR: 'Unable to reset password. The link may be invalid or expired.',
  },
  CANCEL_RESET_PASSWORD: {
    ERROR: 'Failed to cancel password reset. Please try again.',
  },
  FALLBACK_ERROR: 'An unexpected error occurred. Please try again.',
};
